import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/es';
import { API, Storage } from "aws-amplify";
import { Container, Row, Col, Button, Badge, Accordion, Card } from "react-bootstrap";
import { Form, FormText, FormGroup, FormControl, FormLabel } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faInfoCircle, faEnvelope } from '@fortawesome/free-solid-svg-icons'

import OrderSummaryBox from "components/cart/OrderSummaryBox"
import LoaderButton from "../components/LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import Loader from '../components/Loader'
import CardGroup from '../components/common/CardGroup';
import OrderStatusBadge from '../components/common/OrderStatusBadge';

import "./Order.css";
import "components/cart/QuickBuyForm.css";

export default function Order() {  
  const { id } = useParams();
  const history = useHistory();
  const { isAuthenticated, session } = useAppContext();
  const [order, setOrder] = useState(null);
  const [show, setShow] = useState(null);
  const [viewerShow, setViewerShow] = useState(null);
  const [tickets, setTickets] = useState(null);
  const [extras, setExtras] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function onLoad() {
            try {         
                const order = await loadOrder(id); 
                setOrder(order)
                if (order) {
          const show = await loadShow(order.show_uid);
                    setShow(show)
                    if (session && session.viewer) {
                        loadViewerShow(session.viewer._id, order.show_uid)
          }
                }
            } catch (e) {
                onError(e);
            }
        }
    onLoad();
    }, [id]);

    async function loadOrder(order_id) {
        return API.get("vivelo", `/viewers/orders/${order_id}`);
    }

    async function loadShow(show_id) {
        return API.get("vivelo", `/shows/${show_id}`);
    }

    async function loadViewerShow(viewer_id, show_id) {
        const vShow = await API.get("vivelo", `/viewers/viewers/${viewer_id}/shows/${show_id}`);        
        if (vShow) {
            setViewerShow(vShow)
        }
        return vShow
    }

    async function handleLogin() {        
        window.open(`/login?email=${order.payment_info.email}&redirect=/account`, "_blank")
    }

    function handleContactSupport() {
        window.open('https://m.me/vivelo.online', '_blank');
    }

  async function resendTickets() {        
    const result = await API.post("vivelo", `/viewers/orders/${id}/resendTickets`);        
    Notification('success','Tus boletos fueron reenviados al correo registrado en la orden')
    }

    function renderStatus() {
    return <OrderStatusBadge status={order.status} />;
    }

    function renderStatusMessages(order) {
        // For registration orders, they should be automatically approved
        if (order.payment_type === 'REGISTRATION') {
            return <>
                <div className="order-status-highlight">
                    Tu registro ha sido procesado exitosamente.
                </div>
                <div className="order-subtitle"><Col>En breve recibirás tus boletos en el correo registrado: <b><i>{order.payment_info.email}</i></b></Col></div>
                <div className="order-subtitle"><Col>Si adquiriste más de un boleto, recuerda compartirlos con tus invitados para que puedan ingresar al evento.</Col></div>
                {!isAuthenticated && (
                    <div className="order-subtitle">
                        <div className="loginBox">
                            <div className="loginBox-content">
                                <div className="loginBox-icon">
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </div>
                                <div className="loginBox-message">
                                    <h4>¿Ya tienes una cuenta?</h4>
                                    <p>Inicia sesión o regístrate para:</p>
                                    <ul>
                                        <li>Ver el detalle de tus órdenes</li>
                                        <li>Recibir tus códigos de acceso</li>
                                        <li>Gestionar tus boletos</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="loginBox-actions">
                                <Button variant="primary" onClick={handleLogin} className="btn-theme-primary">
                                    Iniciar sesión
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        }

        // For other payment types, use the original logic
        switch (order.status) {
            case 'APPROVED': {
                return <>
          <div className="order-status-highlight">
            {order.payment_type == 'REGISTRATION' ? 'Tu registro ha sido procesado exitosamente.' : '¡Tu compra fue exitosa!'}
          </div>
          <div className="order-subtitle"><Col>En breve recibirás tus boletos en el correo registrado: <b><i>{order.payment_info.email}</i></b></Col></div>
          <div className="order-subtitle"><Col>Si adquiriste más de un boleto, recuerda compartirlos con tus invitados para que puedan ingresar al evento.</Col></div>
                </>
            }
            case 'WAITING_CONFIRMATION': {
                return <>
          <div className="order-status-highlight">
            {order.payment_type == 'REGISTRATION' ? 'Tu registro ha sido procesado exitosamente.' : 'Estamos esperando la confirmación de tu depósito o transferencia.'}
          </div>
          <div className="order-subtitle"><Col>Una vez que tu pago sea verificado, enviaremos tus boletos al correo registrado en la orden: <b><i>{order.payment_info.email}</i></b></Col></div>                    
          <div className="order-subtitle"><Col>El organizador del evento revisará tu comprobante. Este proceso puede tomar hasta 48 horas hábiles.<br />
            Recibirás tus boletos por correo electrónico tan pronto como tu pago sea aprobado.</Col></div>
          {!isAuthenticated && (
            <div className="order-subtitle">
              <div className="loginBox">
                <div className="loginBox-content">
                  <div className="loginBox-icon">
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </div>
                  <div className="loginBox-message">
                    <h4>¿Ya tienes una cuenta?</h4>
                    <p>Inicia sesión o regístrate para:</p>
                    <ul>
                      <li>Ver el detalle de tus órdenes</li>
                      <li>Recibir tus códigos de acceso</li>
                      <li>Gestionar tus boletos</li>
                    </ul>
                  </div>
                </div>
                <div className="loginBox-actions">
                  <Button variant="primary" onClick={handleLogin} className="btn-theme-primary">
                    Iniciar sesión
                  </Button>
                </div>
              </div>
            </div>
          )}
                </>
            }
            default: {
        return <div className="order-status-highlight">
          {order.payment_type == 'REGISTRATION' ? 'Tu registro no ha sido exitoso.' : 'La compra no ha sido exitosa.'}
        </div>
      }
    }
  }

  function renderOrderInfoGrid(order) {
    const isCreditCard = order.payment_type === 'CREDIT_CARD';
    const isBankDeposit = order.payment_type === 'BANK_DEPOSIT';
    const isAccountBankDeposit = order.payment_type === 'ACCOUNT_BANK_DEPOSIT';
    const isRegistration = order.payment_type === 'REGISTRATION';
    const lastFour = order?.payment_info?.cc_number ? order.payment_info.cc_number.slice(-4) : '';
    const depositLog = order.change_log?.find(log =>
      log.action === 'Order deposit confirmed' || log.action === 'Order deposit rejected'
    );
    return (
      <div className="order-info-grid">                
        <div className="order-info-item">
          <div className="order-info-label">Método de Pago</div>
          <div className="order-info-value">
            {isCreditCard && <>Tarjeta de Crédito/Débito {lastFour && <>(•••• {lastFour})</>}</>}
            {isBankDeposit && 'Depósito Bancario'}
            {isAccountBankDeposit && 'Depósito Directo'}
            {isRegistration && 'Registro Gratuito'}
          </div>
        </div>
        {order.payment_response?.authorization && (
          <div className="order-info-item">
            <div className="order-info-label">Autorización</div>
            <div className="order-info-value">{order.payment_response.authorization}</div>
          </div>
        )}
        {order.payment_response?.transaction_id && (
          <div className="order-info-item">
            <div className="order-info-label">ID de Transacción</div>
            <div className="order-info-value">{order.payment_response.transaction_id}</div>
                </div>
        )}
        {(isBankDeposit || isAccountBankDeposit) && order.payment_info?.reference && (
          <div className="order-info-item">
            <div className="order-info-label">Referencia</div>
            <div className="order-info-value">{order.payment_info.reference}</div>
                </div>
        )}
        {(isBankDeposit || isAccountBankDeposit) && depositLog && (
          <div className="order-info-item">
            <div className="order-info-label">Estado</div>
            <div className="order-info-value">
              {depositLog.action === 'Order deposit confirmed' ? 'Confirmado' : 'Rechazado'}
              {depositLog.reason && ` - ${depositLog.reason}`}
            </div>
          </div>
        )}
        {(isBankDeposit || isAccountBankDeposit) && order.payment_response?.response_text && (
          <div className="order-info-item">
            <div className="order-info-label">Comentario</div>
            <div className="order-info-value">{order.payment_response.response_text}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    order ?
    <div className="Order content content-dark order-detail-grid">
      <div className="order-confirm-banner">
        <div className="order-confirm-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="url(#paint0_linear)"/>
            <path d="M16 25.5L21 30.5L32 19.5" stroke="white" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
              <linearGradient id="paint0_linear" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                <stop stopColor="#cb0f7e"/>
                <stop offset="1" stopColor="#ff6a00"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="order-confirm-title">
          {order.payment_type === 'REGISTRATION' ? '¡Registro exitoso!' :
           order.payment_type === 'CREDIT_CARD' ? '¡Compra exitosa!' :
           (order.payment_type === 'BANK_DEPOSIT' || order.payment_type === 'ACCOUNT_BANK_DEPOSIT') ? 'Tu orden ha sido registrada' :
           '¡Compra exitosa!'}
        </div>
        <div className="order-confirm-subtitle">
          {(order.payment_type === 'BANK_DEPOSIT' || order.payment_type === 'ACCOUNT_BANK_DEPOSIT') 
            ? 'Recibirás tus boletos cuando el productor del evento confirme tu depósito o transferencia'
            : 'Tu orden ha sido confirmada'}
        </div>
      </div>

      <CardGroup 
        title={`Orden #${order._id}`}
        description={`Confirmada el ${moment(order.createdAt).locale('es').format('D [de] MMMM [de] YYYY - HH:mm')}`} 
        extra={renderStatus()}
      >
        <div className="order-header">
          <div className="order-header-main">
            {renderOrderInfoGrid(order)}
          </div>
          <div className="order-status-messages">
            {renderStatusMessages(order)}
          </div>
        </div>
        <div className="order-summary-section">
          <div className="order-actions">
            {order.status === 'APPROVED' && <button className="btn-theme-secondary" onClick={resendTickets}>Reenviar Correo</button>}
            <button className="btn-theme-secondary" onClick={() => window.print()}>Imprimir</button>
          </div>
          <div style={{marginTop: 20, paddingTop: 20}}>
            <OrderSummaryBox order={order} />
          </div>
        </div>
      </CardGroup>

      <div className="order-footer-section">
        <div className="order-footer-infobox">
          <div className="order-footer-infobox-title">
            <FontAwesomeIcon icon={faInfoCircle} className="order-footer-infobox-icon" /> Información importante
          </div>
          <ul className="order-footer-infobox-list">
            <li>Recibirás un correo de confirmación de la orden</li>
            <li>Recibirás un correo por cada boleto adquirido. Puedes reenviarlo a tus invitados para que puedan ingresar al evento.</li>
            <li>Presenta el código QR en tu teléfono o impreso en la entrada</li>
            <li>Llega al menos 30 minutos antes del evento para evitar filas o imprevistos</li>
            <li>Todas las compras son finales y no reembolsables, salvo en casos excepcionales en los que el evento sea cancelado</li>
          </ul>
        </div>
        <div className="order-footer-support">
          <span>¿Tienes alguna pregunta sobre tu orden?</span>
          <div className="order-footer-support-actions">
            <button className="btn-theme-secondary order-footer-support-btn" onClick={handleContactSupport}>
              <FontAwesomeIcon icon={faEnvelope} /> Contactar soporte
            </button>
            <a href="/account" className="order-footer-support-link">← Ver mis órdenes</a>
          </div>
        </div>
      </div>
    </div>
    : <Loader />
  );
}